import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import AboutUs from "../views/aboutus/index";
import aboutIncocegla from "../views/aboutus/aboutIncocegla.vue";
import OurFacilities from "../views/aboutus/ourFacilities.vue";
import GlaucomaClub from "../views/aboutus/glaucomaClub.vue";
import IncoceglaFoundation from "../views/aboutus/incoceglaFoundation.vue";
import Areas from "../views/areas/index.vue";
import DoctorAndDepartments from "../views/areas/medicalEquipment/doctorsAndDepartments";
//import OtherAreas from '../views/areas/medicalEquipment/otherAreas';
import MedicalInsurance from "../views/areas/patients/medicalInsurance";
import PathologiesMoreConsulted from "../views/areas/patients/pathologiesMoreConsulted";
import FAQ from "../views/areas/patients/faq";
import News from "../views/news";
import NewDetails from "../views/newDetails.vue";
import ContactUs from "../views/contactUs.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about-us",
    name: "aboutUs",
    component: AboutUs,
    redirect: { name: "aboutIncocegla" },
    children: [
      {
        path: "about-incocegla",
        name: "aboutIncocegla",
        component: aboutIncocegla,
      },
      {
        path: "our-facilities",
        name: "ourFacilities",
        component: OurFacilities,
      },
      {
        path: "glaucoma-club",
        name: "glaucomaClub",
        component: GlaucomaClub,
      },
      {
        path: "incocegla-foundation",
        name: "incoceglaFoundation",
        component: IncoceglaFoundation,
      },
    ],
  },
  {
    path: "/areas",
    name: "areas",
    component: Areas,
    children: [
      {
        path: "doctors-and-departments",
        name: "doctorsAndDepartments",
        component: DoctorAndDepartments,
      },
      {
        path: "other-areas",
        name: "otherAreas",
        props: (route) => ({ department: route.query.department }),
        component: DoctorAndDepartments,
        //component: OtherAreas
      },
      {
        path: "medical-insurance",
        name: "medicalInsurance",
        component: MedicalInsurance,
        meta: { visible: true },
      },
      {
        path: "pathologies-more-consulted",
        name: "pathologiesMoreConsulted",
        props: (route) => ({ pathology: route.query.pathology }),
        component: PathologiesMoreConsulted,
      },
      {
        path: "faq",
        name: "faq",
        component: FAQ,
      },
    ],
  },

  {
    path: "/news",
    name: "news",
    component: News,
   
  },

  {
	path: "/news/:slug",
	name: "newDetails",
	component: NewDetails,
	// meta: { visible: true },
  },
  {
    path: "/contact-us",
    name: "contactUs",
    component: ContactUs,
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
